export default __webpack_public_path__ + "static/media/ts5.22ac9f64.png";